module.exports = __webpack_public_path__ + "static/media/delivery.f0ece1ea.png";